import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 2v20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 5h20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 3v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 3v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 3v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 3v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19 5-7 7-7-7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UtilityPole";
const UtilityPole = memo(themed(Icon));
export {
  UtilityPole
};
//# sourceMappingURL=utility-pole.js.map
